export interface FAQ {
  id: number
  question: string
  answer: string
}

export interface Benefit {
  id: number
  text: string
}

export interface HowItWorks {
  id: number
  title: string
  benefits: Benefit[]
}

export interface ZetPrimeProduct {
  id: number
  url: string
}

export interface LandingPageContentResponse {
  bannerText: string
  amount: string
  bannerImage: string
  bannerStrip: string
  faqs: FAQ[]
  howItWorks: HowItWorks
  zetPrimeProducts: ZetPrimeProduct[]
}

export type SubscriptionStatus =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'EXPIRED'
  | 'CANCELLED'
  | 'FAILED'
  | 'RENEWAL_PENDING'

export interface SubscriptionInfoResponse {
  userId: number
  primeCategories: number[]
  status: SubscriptionStatus
  validTill: string
  earningsTillDate: number
}

export const DEFAULT_LANDING_PAGE_CONTENT: LandingPageContentResponse = {
  bannerText: '',
  amount: '99',
  bannerImage: '',
  bannerStrip: '',
  faqs: [],
  howItWorks: {
    id: 0,
    title: '',
    benefits: [],
  },
  zetPrimeProducts: [],
}
